<template>
  <v-card color="transparent" :outlined="readonly" :flat="flat">
    <v-simple-table v-if="!readonly" dense class="transparent pb-2">
      <template v-slot:default>
        <thead v-if="showHeaders">
          <tr>
            <th v-if="headers && headers.length" width="70%">
              <slot name="title">
                {{ headers[0] }}
              </slot>
            </th>
            <th v-for="(h, i) in headers" :hidden="i != 0" :key="i">
              {{ h }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in items" :key="i">
   
            <td class="pt-2">
              <input
              v-if="!multiline && !rich"
                @input="update"
                style="width: 100%;"
                class="emailInput"
                :placeholder="`${label}...`"
                text
                v-model="item[valueField]"
                :readonly="readonly"
              />
              <textarea v-if="multiline && !rich"   @input="update"
                style="width: 100%;"
                class="emailInput"
                :placeholder="`${label}...`"
                text
                outlined
                dense
                v-model="item[valueField]"
                :readonly="readonly">
              </textarea>
              <wysiwyg 
                v-if="rich && !readonly" 
                v-model="item[valueField]" 
                @change="update"
                :options="{
                  link: {
                    url: 'http://'
                  }
                }"
                >

              </wysiwyg>
        
                
            </td>
            <td v-if="hasPrimary && !readonly" width="10%" class="text-center">
              <v-checkbox
                dense
                v-model="item.primary"
                @change="update"
              ></v-checkbox>
            </td>
            <td v-if="hasPrimary && readonly">
              <i class="fas fa-check green--text" v-if="item.primary"></i>
            </td>
            <td v-if="tags.length != 0 && item.tags" width="25%">
              <v-select multiple chips @blur="update" :items="tags" label="tags" v-model="item.tags"></v-select>
            </td>
            <td v-if="!readonly" width="10%" class="text-center">
              <v-btn size="sm" icon @click="removeItem(i)">
                <i class="fas fa-times"></i>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else class="d-flex flex-wrap d-print-block"> 
      <v-card class="ma-2" v-for="(item, i) in items" :key="i">
        <v-card-text v-html="item[valueField]"></v-card-text>
      </v-card>
    </div>
    
    <v-card-text v-if="readonly && items.length == 0"
      >No {{ label | pluralize }} listed</v-card-text
    >
    <v-card-actions v-if="!readonly">
      <v-btn block small text @click="addItem"
        ><v-icon left>fal fa-plus</v-icon> {{ label }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import entities from "../../objects/entities.js";
export default {
  name: "TextFieldArray",
  data() {
    return { e: entities };
  },
 
  methods: {

     person(i){
      return i.metadata ? i.metadata.createdBy : null; 
    },
    setValue(e){
      this.items[e.index][this.valueField] = e.html;
      this.update();
    },
    addItem() {
      if (this.type) {
        var i = {};
        i =  this.$r.clone(this.e[this.type]);
        if(i.metadata != null){
          i.metadata.createdBy = this.$auth.userId;
          i.metadata.created = new Date();
        }
        this.items.push(i);
      } else {
        this.items.push(null);
      }
      this.$emit("change", this.items);
    },
    removeItem(i) {
      debugger;
      var hasValue = this.items[i][this.valueField]; 
      var confirm = hasValue ? window.confirm(`Are you sure you want to remove this ${this.label.toLowerCase()}? This action cannot be undone.`) : true; 
      if(confirm){
        this.items.splice(i, 1);
        this.$emit("change", this.items);
      }
    },
    update() {
      this.$emit("change", this.items);
    },
  },
  computed: {
   
    headers() {
      var result = [this.label];
      if (this.hasPrimary) {
        if (this.readonly) {
          result.push("Primary");
        } else {
          result.push("Primary?");
        }
      }
      if (!this.readonly) {
        result.push("Remove");
      }
      return result;
    },
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
       rich:{
      type: Boolean,
      default: false
    },
  
    readonly: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: null,
    },
    multiline:{
      type: Boolean,
      default: false
    },
    valueField: {
      type: String,
    },
    hasPrimary: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Item",
    },
    showHeaders:{
      type: Boolean,
      default: true
    },
    tags:{
      type: Array,
      default: function(){
        return [];
      }
    },
    allowCreateTags:{
        type: Boolean
    }
  },
};
</script>
